import(/* webpackMode: "eager", webpackExports: ["BlogHero"] */ "/vercel/path0/src/components/blogHero/blogHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPosts"] */ "/vercel/path0/src/components/blogPosts/blogPosts.comp.tsx");
